import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import Form, {FormBody, FormActions, SelectInput, TextInput} from '../../Form';
import {timezones} from "../../../libs/date";

@inject('imageSourceStore', 'imageSourceDeviceStore', 'stationStore')
@observer
class ImageSourceDeviceAdd extends Component {
  static propTypes = {
    route: PropTypes.object.isRequired,
    imageSourceStore: PropTypes.object.isRequired,
    imageSourceDeviceStore: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  @observable item = {
    imagesource_id: this.props.params.id,
    device_code: '',
    station_id: ''
  };

  slug = `/idaq/image_source/${this.props.params.id}/devices`;

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }

  @action onChangeItem = (key, value) => this.item[key] = value;

  handleSave(e) {
    e.preventDefault();

    const {imageSourceDeviceStore} = this.props;
    const {notify} = this.context;

    imageSourceDeviceStore.createItem(this.item)
      .then(() => {
        notify.success({message: 'Success'});
        this.context.router.push(this.slug);
      })
      .catch(err => {
        notify.error(err);
      });
  }

  render() {
    const {imageSourceStore, imageSourceDeviceStore, stationStore, params: {id}} = this.props;
    let imagesource = imageSourceStore.findById(id);

    return (
      <Modal title={`Add ${imagesource.name} Device`} slug={this.slug} isSaving={imageSourceDeviceStore.isSaving} handleSave={this.handleSave}>
        {imageSourceDeviceStore.isLoading ? <Spinner/> : <Form>
          <FormBody>
            <TextInput label={'Device Code'} value={this.item.device_code} onChange={e => this.onChangeItem('device_code', e.target.value)}/>
            <SelectInput
              label={'Station'}
              value={this.item.station_id}
              onChange={e => this.onChangeItem('station_id', e.target.value)}
              options={stationStore.items}
              fields={{value: 'id', label: 'name'}}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>}
      </Modal>
    );
  }
}

export default ImageSourceDeviceAdd;


// WEBPACK FOOTER //
// ./src/components/IDaq/ImageSourceDevices/ImageSourceDeviceAdd.js